import React from 'react';
import Truck from '../../../icons-af/truck';
import './freeShipping.scss';

const FreeShipingCue = ({}: propTypes) => {
  return (
    <span className="icon--container">
      <Truck />
      <span className="icon--contents">Free Delivery</span>
    </span>
  );
};

interface propTypes {}

export default FreeShipingCue;
